module.exports = __webpack_public_path__ + "src/client/components/PasswordResetPage/img/logo-worklayer-blue.png";